import {combineReducers, configureStore} from '@reduxjs/toolkit'
import home from './home'
import course from './course'
import classStore from './class'
import courseCategory from './courseCategory'
import courseComment from './courseComment'
import courseQuestion from './courseQuestion'
import user from './user'
import offCode from './offCode'
import userCategory from './userCategory'
import province from './province'

const reducer = combineReducers({
    home,
    course,
    classStore,
    courseCategory,
    courseComment,
    courseQuestion,
    user,
    offCode,
    userCategory,
    province,
})
const store = configureStore({reducer,})
export default store;
